import { GenerateSocialCopyMeta, GenerateSocialCopyPayload } from 'types/store/GenerateSocialCopy';
import { createAsyncReducer } from 'utils/Redux';

import { generateSocialCopyActions } from '../actions';

export default createAsyncReducer<GenerateSocialCopyMeta, GenerateSocialCopyPayload>(generateSocialCopyActions);
